import { http } from '@/utils'

export const hrmSaveEducation = (data: any): any => http.post(`/hrm/education`, data)

export const hrmDeleteEducation = (data: any): any => http.delete(`/hrm/education`, { data })

export const hrmEducationList = (data: any): any => http.post(`/hrm/educations`, data)
